import React from 'react';
import { CheckIcon } from 'lucide-react';
import { beneficiosRiesgo } from '../data/content';
export function Risk() {
  return <section className="w-full bg-ink-strong" aria-labelledby="riesgo-titulo" data-id="element-142" data-mp="1trgmwy9ao1aj">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:px-6 sm:py-14" data-id="element-143" data-mp="1g0brk8cylv60">
        <div className="grid grid-cols-1 gap-7 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-144" data-mp="1k2q9mq8t0qw8">
          <div data-id="element-145" data-mp="16374857dntnm">
            <h2 id="riesgo-titulo" className="font-display text-[1.6rem] leading-[1.05] text-white sm:text-4xl" data-id="element-146" data-mp="162nwtifcsnnu">
              Una sola mala reseña te cuesta más que este pack completo.
              Protegete hoy mismo.
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-147" data-mp="11449bdl433td">
              Una limpieza mal coordinada, una respuesta impulsiva, un check-in
              confuso o una queja mal gestionada pueden bajar tu calificación y
              afectar tus próximas reservas.
            </p>
            <p className="mt-2 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-148" data-mp="2t3ibcdu8xgtr">
              Host Automático™ está diseñado para evitar esos errores antes de
              que te cuesten dinero.
            </p>
          </div>

          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-149" data-mp="32sa0yfbu3p1i">
            {beneficiosRiesgo.map(item => <li key={item} className="flex items-start gap-2 rounded-lg bg-white/5 px-3 py-2.5" data-id="element-150" data-mp="2xvjlnu7usxh5">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success-light" strokeWidth={3} aria-hidden="true" data-id="element-151" data-mp="255ktvr29ym8s" />
                <span className="text-[13px] font-medium leading-snug text-white/90" data-id="element-152" data-mp="2k0h9ipceybvw">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}